import React from 'react';

export const MapPin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M12.0002 14.6666C12.0002 15.7275 12.4216 16.7449 13.1717 17.4951C13.9219 18.2452 14.9393 18.6666 16.0002 18.6666C17.061 18.6666 18.0784 18.2452 18.8286 17.4951C19.5787 16.7449 20.0002 15.7275 20.0002 14.6666C20.0002 13.6058 19.5787 12.5884 18.8286 11.8382C18.0784 11.0881 17.061 10.6666 16.0002 10.6666C14.9393 10.6666 13.9219 11.0881 13.1717 11.8382C12.4216 12.5884 12.0002 13.6058 12.0002 14.6666Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5428 22.2093L17.8855 27.8666C17.3855 28.3662 16.7076 28.6467 16.0008 28.6467C15.2941 28.6467 14.6162 28.3662 14.1162 27.8666L8.4575 22.2093C6.9658 20.7175 5.94995 18.8169 5.53842 16.7478C5.12689 14.6787 5.33815 12.534 6.14551 10.5849C6.95286 8.6359 8.32003 6.97003 10.0741 5.79799C11.8283 4.62594 13.8905 4.00037 16.0002 4.00037C18.1098 4.00037 20.1721 4.62594 21.9262 5.79799C23.6803 6.97003 25.0475 8.6359 25.8548 10.5849C26.6622 12.534 26.8734 14.6787 26.4619 16.7478C26.0504 18.8169 25.0345 20.7175 23.5428 22.2093Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
